module.exports = __webpack_public_path__ + "img/bro2.80dd577a.jpg";